<template>
    <div>
        <v-list>
            <template v-for="(comment, i) in comments">
                <v-divider v-if="i > 0" :key="`divider-${comment.id}`" inset></v-divider>
                <template v-if="comment.id === editingId">
                    <v-list-item class="ml-12 pl-6" :key="`edit-${comment.id}`">
                        <v-list-item-content>
                            <div>
                                <v-textarea
                                    v-model="editComment"
                                    filled
                                    auto-grow
                                    outlined
                                    rows="2"
                                    class="mb-n6"
                                    counter="4000"
                                    :rules="rules"
                                ></v-textarea>
                                <div class="float-right">
                                    <v-btn
                                        small
                                        :loading="isSaving"
                                        :disabled="isSaving"
                                        color="primary"
                                        @click="saveEditComment"
                                        >Save</v-btn
                                    >
                                    <v-btn
                                        small
                                        :loading="isSaving"
                                        :disabled="isSaving"
                                        color="error"
                                        @click="clearEdit"
                                        class="ml-2"
                                        >Cancel</v-btn
                                    >
                                </div>
                            </div>
                        </v-list-item-content>
                    </v-list-item>
                </template>
                <comment v-else :comment="comment" :key="i" @beginEdit="beginEdit" @beginDelete="beginDelete"></comment>
                <template v-for="(child, i) in comment.childComments">
                    <v-divider :key="`c-divider-${child.id}`" inset></v-divider>
                    <template v-if="child.id === editingId">
                        <v-list-item class="ml-12 pl-6" :key="`edit-${child.id}`">
                            <v-list-item-content>
                                <div>
                                    <v-textarea
                                        v-model="editComment"
                                        filled
                                        auto-grow
                                        outlined
                                        rows="2"
                                        class="mb-n6"
                                        counter="4000"
                                        :rules="rules"
                                    ></v-textarea>
                                    <div class="float-right">
                                        <v-btn
                                            small
                                            :loading="isSaving"
                                            :disabled="isSaving"
                                            color="primary"
                                            @click="saveEditComment"
                                            >Save</v-btn
                                        >
                                        <v-btn
                                            small
                                            :loading="isSaving"
                                            :disabled="isSaving"
                                            color="error"
                                            @click="clearEdit"
                                            class="ml-2"
                                            >Cancel</v-btn
                                        >
                                    </div>
                                </div>
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                    <comment
                        v-else
                        :comment="child"
                        :is-last-child="i === comment.childComments.length - 1"
                        :key="`c-${child.id}`"
                        class="ml-12"
                        @beginEdit="beginEdit"
                        @beginDelete="beginDelete"
                    ></comment>
                </template>
                <v-list-item class="ml-12 pl-6" :key="`reply-${comment.id}`">
                    <template v-if="comment.id === activeReply">
                        <v-list-item-avatar size="32">
                            <v-icon>mdi-arrow-right-bottom</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <div>
                                <v-textarea
                                    :ref="`reply-${comment.id}`"
                                    v-model="replyComment"
                                    clearable
                                    filled
                                    auto-grow
                                    outlined
                                    placeholder="Write a reply..."
                                    rows="2"
                                    class="mb-n6"
                                    :rules="rules"
                                    counter="4000"
                                ></v-textarea>
                                <div class="float-right">
                                    <v-btn
                                        small
                                        :loading="isSaving"
                                        :disabled="isSaving"
                                        color="success"
                                        @click="saveReplyComment"
                                        >Save</v-btn
                                    >
                                    <v-btn
                                        small
                                        :loading="isSaving"
                                        :disabled="isSaving"
                                        color="error"
                                        @click="clearReply"
                                        class="ml-2"
                                        >Cancel</v-btn
                                    >
                                </div>
                            </div>
                        </v-list-item-content>
                    </template>
                    <template v-else-if="comment.id !== editingRootId">
                        <v-list-item-content class="mt-n8">
                            <div>
                                <div class="float-right">
                                    <v-btn
                                        small
                                        :loading="isSaving"
                                        :disabled="isSaving"
                                        color="secondary"
                                        @click="reply(comment.id)"
                                        >Reply</v-btn
                                    >
                                </div>
                            </div>
                        </v-list-item-content>
                    </template>
                </v-list-item>
            </template>
            <v-divider inset></v-divider>
            <v-list-item class="ml-12">
                <v-list-item-content>
                    <v-list-item-title>New Comment</v-list-item-title>
                    <v-form ref="newComment">
                        <v-textarea
                            v-model="newComment"
                            clearable
                            filled
                            auto-grow
                            outlined
                            placeholder="Add a comment..."
                            rows="2"
                            class="mb-n6"
                            :rules="rules"
                            counter="4000"
                        ></v-textarea>
                        <div class="float-right" v-if="newComment">
                            <v-btn :loading="isSaving" :disabled="isSaving" color="secondary" @click="saveNewComment"
                                >Save</v-btn
                            >
                            <v-btn
                                :loading="isSaving"
                                :disabled="isSaving"
                                color="error"
                                @click="clearNewComment"
                                class="ml-2"
                                >Cancel</v-btn
                            >
                        </div>
                    </v-form>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </div>
</template>
<script>
import comment from './Comment'
export default {
    components: {
        comment,
    },
    props: {
        comments: {
            type: Array,
            required: true,
        },
        isSaving: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            newComment: '',
            activeReply: 0,
            replyComment: '',
            editingId: 0,
            editingRootId: 0,
            editComment: '',
            rules: [v => !v || v.length <= 4000 || 'Comment is too long - limit to 4000 characters'],
        }
    },
    methods: {
        reply(commentId, parentId) {
            let newParent = parentId || commentId
            this.clearEdit()
            if (this.activeReply !== newParent) {
                this.replyComment = ''
                this.activeReply = newParent
                let refItem = `reply-${newParent}`
                this.$nextTick(() => this.$refs[refItem][0].focus())
            }
        },
        saveNewComment() {
            if (!this.$refs.newComment.validate()) return
            let comment = {
                comment: this.newComment,
            }
            this.saveComment(comment)
            this.clearNewComment()
        },
        saveReplyComment() {
            let comment = {
                comment: this.replyComment,
                parentId: this.activeReply,
            }
            this.saveComment(comment)
        },
        saveEditComment() {
            let comment = {
                comment: this.editComment,
                editParentId: this.editingId,
            }
            this.saveEdit(comment)
        },
        saveComment(comment) {
            this.$emit('save', comment)
            this.clearReply()
        },
        saveEdit(comment) {
            this.$emit('edit', comment)
            this.clearEdit()
        },
        clearNewComment() {
            this.newComment = ''
        },
        clearReply() {
            this.activeReply = 0
            this.replyComment = ''
        },
        clearEdit() {
            this.editingId = 0
            this.editingRootId = 0
            this.editComment = ''
        },
        beginEdit(editParentId, comment, editingRootId) {
            this.clearReply()
            this.editComment = comment
            this.editingId = editParentId
            this.editingRootId = editingRootId || editParentId
        },
        beginDelete(commentId) {
            this.$confirm({
                title: 'Confirm Delete',
                body: 'Are you sure you want to delete this comment?',
            }).then(res => {
                if (res) {
                    this.$emit('delete', commentId)
                }
            })
        },
    },
}
</script>
